import {
    ADD_JOURNAL_VOUCHER_LINE_REQUEST    ,
    ADD_JOURNAL_VOUCHER_LINE_SUCCESS    ,
    ADD_JOURNAL_VOUCHER_LINE_ERROR      ,
    GET_ONE_JOURNAL_VOUCHER_LINE_REQUEST,
    GET_ONE_JOURNAL_VOUCHER_LINE_SUCCESS,
    GET_ONE_JOURNAL_VOUCHER_LINE_ERROR  ,
    UPDATE_JOURNAL_VOUCHER_LINE_REQUEST ,
    UPDATE_JOURNAL_VOUCHER_LINE_SUCCESS ,
    UPDATE_JOURNAL_VOUCHER_LINE_ERROR   ,
} from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case ADD_JOURNAL_VOUCHER_LINE_REQUEST:
            return {
                loading: true,
            };
        case ADD_JOURNAL_VOUCHER_LINE_SUCCESS:
            return {
                ...state,
                loading: false,
                payload: [payload],
            };
        case ADD_JOURNAL_VOUCHER_LINE_ERROR:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_ONE_JOURNAL_VOUCHER_LINE_REQUEST:
            return {
                loading: true,
            };
        case GET_ONE_JOURNAL_VOUCHER_LINE_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_ONE_JOURNAL_VOUCHER_LINE_ERROR:
            return {
                ...state,
                loading: false,
                payload,
            };
        case UPDATE_JOURNAL_VOUCHER_LINE_REQUEST:
            return {
                loading: true,
            };
        case UPDATE_JOURNAL_VOUCHER_LINE_SUCCESS:
            return {
                ...state,
                loading: false,
                payloadUpdate: [payload],
            };
        case UPDATE_JOURNAL_VOUCHER_LINE_ERROR:
            return {
                ...state,
                loading: false,
                payloadUpdate: [payload],
            };

        default:
            return state;
    }
}
